import {pushEcommerceEvent} from './gtm/ga4DataLayer'

const NO_APPLICABLE_PROMOTION = 'no_applicable_promotion'

export function getCouponFeedbackMessage({statusCode, code, formatMessage}) {
    if (statusCode === NO_APPLICABLE_PROMOTION) {
        return formatMessage({
            id: 'use_promocode.error.minimum_not_met',
            defaultMessage:
                "The discount could not be applied because your cart doesn't meet all the requirements for this coupon. Please contact Customer Service for further assistance."
        })
    }

    return formatMessage(
        {
            id: 'use_promocode.error.not_valid',
            defaultMessage: 'Coupon code {code} is not valid.'
        },
        {code}
    )
}

export function extractCouponsFromBasket(basketResponse) {
    const coupons = []
    const couponMap = new Map()
    const couponIdMap = new Map()
    const couponStatusMap = new Map()
    const promotionNameMap = new Map()

    if (!basketResponse) return coupons

    const appliedCouponCodes = new Set()
    const allCouponCodes = new Set()

    if (basketResponse.couponItems && Array.isArray(basketResponse.couponItems)) {
        basketResponse.couponItems.forEach((item) => {
            allCouponCodes.add(item.code)
            couponIdMap.set(item.code, item.couponItemId)

            if (item.statusCode) {
                couponStatusMap.set(item.code, item.statusCode)
            }

            if (item.statusCode === 'applied') {
                appliedCouponCodes.add(item.code)
            }
        })
    }

    if (
        basketResponse.orderPriceAdjustments &&
        Array.isArray(basketResponse.orderPriceAdjustments)
    ) {
        basketResponse.orderPriceAdjustments.forEach((adjustment) => {
            if (adjustment.couponCode && appliedCouponCodes.has(adjustment.couponCode)) {
                const discountValue = Math.abs(adjustment.price || 0)
                couponMap.set(adjustment.couponCode, {
                    discountAmount:
                        (couponMap.get(adjustment.couponCode)?.discountAmount || 0) + discountValue,
                    lineItems: couponMap.get(adjustment.couponCode)?.lineItems
                })
                promotionNameMap.set(adjustment.couponCode, adjustment.itemText)
            }
        })
    }

    if (basketResponse.productItems && Array.isArray(basketResponse.productItems)) {
        basketResponse.productItems.forEach((product) => {
            if (product.priceAdjustments && Array.isArray(product.priceAdjustments)) {
                product.priceAdjustments.forEach((adjustment) => {
                    if (adjustment.couponCode && appliedCouponCodes.has(adjustment.couponCode)) {
                        const discountValue = Math.abs(adjustment.price || 0)
                        const lineItems = couponMap.get(adjustment.couponCode)?.lineItems || []
                        lineItems.push({
                            productId: product.productId,
                            productName: product.productName,
                            quantity: product.quantity,
                            price: product.price,
                            discountAmount: discountValue
                        })
                        couponMap.set(adjustment.couponCode, {
                            discountAmount:
                                (couponMap.get(adjustment.couponCode)?.discountAmount || 0) +
                                discountValue,
                            lineItems
                        })
                        promotionNameMap.set(adjustment.couponCode, adjustment.itemText)
                    }
                })
            }
        })
    }

    allCouponCodes.forEach((code) => {
        const discountValue = couponMap.get(code)?.discountAmount || 0
        const statusCode = couponStatusMap.get(code)

        coupons.push({
            couponCode: code,
            promotionName: promotionNameMap.get(code) || code,
            couponValue: discountValue > 0 ? -discountValue : 0,
            couponItemId: couponIdMap.get(code),
            statusCode: statusCode || null,
            isApplied: appliedCouponCodes.has(code),
            lineItems: couponMap.get(code)?.lineItems
        })
    })

    return coupons
}

export const pushCouponEvent = (couponId, basketRes, products, isApplied) => {
    const allCoupons = extractCouponsFromBasket(basketRes)
    const couponData = allCoupons.find(
        (coupon) =>
            coupon.couponItemId === couponId ||
            coupon.couponCode?.toLowerCase() === couponId?.toLowerCase()
    )
    if (window.dataLayer && couponData) {
        let data = {
            currency: basketRes.currency
        }
        if (couponData?.lineItems && couponData?.lineItems.length > 0) {
            data.items = couponData.lineItems.map((lineItem) => {
                let product = products?.[lineItem.productId]
                return {
                    item_id: product?.master?.masterId || product?.id,
                    item_name: lineItem.productName || product?.name,
                    affiliation: 'Cavenders',
                    discount: lineItem.discountAmount,
                    item_brand: product?.brand || product?.manufacturerName || '',
                    item_category: product?.primaryCategoryId || product?.c_primaryCatergoryID,
                    item_variant: product?.id,
                    price: lineItem.price,
                    quantity: lineItem.quantity,
                    coupon: couponData.couponCode
                }
            })
        } else {
            data.coupon = couponData.couponCode
            data.discount = couponData.couponValue * -1
        }
        pushEcommerceEvent(isApplied ? 'promo_code_applied' : 'promo_code_removed', data)
    }
}
